import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Rack } from "src/services/item/rack.interface";

@Component({
  selector: "rc-scan-rack-modal",
  templateUrl: "./scan-rack-modal.component.html",
  styleUrls: ["./scan-rack-modal.component.scss"],
  standalone: false,
})
export class ScanRackModalComponent {
  constructor(private readonly modalController: ModalController) {}

  public async handleQrCodeScanned(rack: Rack): Promise<void> {
    await this.modalController.dismiss(rack);
  }
}
